"use client"

import type {
  ProfileOffersView,
  SwapProtocolIdentifier,
  Timeframe,
} from "@opensea/graphql"
import { createContext, type PropsWithChildren, useContext } from "react"
import type { ActivityTypeQueryParam } from "@/hooks/query-param/use-activity-type-query-param"
import type { CollectionOfferStatus } from "@/hooks/query-param/use-collection-offer-status-query-param"
import type { OfferStatusQueryParam } from "@/hooks/query-param/use-offer-status-query-param"
import type { OrderStatusQueryParam } from "@/hooks/query-param/use-order-status-query-param"
import type { RelayerQueryParam } from "@/hooks/query-param/use-relayer-query-param"
import type { Status } from "@/hooks/query-param/use-status-query-param"

export type FilterDefaults = {
  statuses?: Status[]
  offerStatuses?: OfferStatusQueryParam[]
  activityTypes?: ActivityTypeQueryParam[]
  timeframe?: Timeframe
  collectionOffersStatuses?: CollectionOfferStatus[]
  orderStatuses?: OrderStatusQueryParam[]
  offersView?: ProfileOffersView
  isVerified?: boolean
  relayer?: RelayerQueryParam | SwapProtocolIdentifier
  sortBy?:
    | "rarity"
    | "cost"
    | "floor_price"
    | "top_offer"
    | "created_date"
    | "received_date"
    | "last_sale_price"
    | "listed_date"
    | "listing_own_price"
}

const FilterDefaultsContext = createContext<FilterDefaults>({
  offersView: "MADE",
})

type Props = PropsWithChildren<FilterDefaults>

export function FilterDefaultsProvider({ children, ...defaults }: Props) {
  const parentDefaults = useFilterDefaults()

  const mergedDefaults = { ...parentDefaults, ...defaults }

  return (
    <FilterDefaultsContext.Provider value={mergedDefaults}>
      {children}
    </FilterDefaultsContext.Provider>
  )
}

export function useFilterDefaults() {
  return useContext(FilterDefaultsContext)
}
